import './bonappetitford/style';
import FormStructure from './bonappetitford/form_structure';

export default FormStructure;